import React, { useEffect, useRef, useState } from 'react';
import { ReactReader } from 'react-reader';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import { NavItem, Rendition } from 'epubjs';
import LoaderFull from '../components/LoaderFull';
import axiosInstance from '../api/apiClient';
const NoCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

function Reader() {
  const params = useParams();
  const [location, setLocation] = useState<string>('');
  const [bookInfo, setBookInfo] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState('')
  const rendition = useRef<Rendition | undefined>(undefined)
  const toc = useRef<NavItem[]>([]);
  const [percentage, setPercentage] = useState(0);
  const [fisicalPage, setFisicalPage] = useState(0);


  const getLocation = async () => {
    const userId = JSON.parse(localStorage.getItem('user') || '{}').user_id;
    const response:any = await axiosInstance.get(`/getProgress/${params.bookId}?userId=${userId}`)
    setLocation(response.location);
    setPageNumber();
  }

  const setPageNumber = () => {
    if (rendition.current && toc.current) {
        const { displayed, href } = rendition.current.location.start
        const chapter = toc.current.find((item) => item.href === href)
        setPage(
            `Page ${displayed.page} of ${displayed.total} in chapter ${
                chapter ? chapter.label : 'n/a'
            }`
        )
    }

    const r = rendition.current?.book
    if (r) {
        r.ready.then(() => {
            if (location) {
                const percent = r.locations.percentageFromCfi(location);
                setPercentage(Math.round(percent * 100));
            }
        });
    }
  }

  const setNewLocation = (loc: string) => {
    setLocation(loc);
    setPageNumber();

    if (loc.startsWith('epubcfi(')) {
        
        const body = {
        "userId": JSON.parse(localStorage.getItem('user') || '{}').user_id,
        "location": loc
        }

        axiosInstance.post(`/library/setProgress/${params.bookId}`, body);

        }
  }

  const getBookInfo = () => {
    axiosInstance.get(`/getBook/${params.bookId}`)
        .then((data:any) => {
            setBookInfo(data[0]);
            setLoading(false);
        });
  }

  useEffect(() => {
    getLocation();
    getBookInfo();
  }, [params.bookId]);

    useEffect(() => {
    
        if (rendition.current) {
            setPageNumber();
        }
    }, [rendition.current]);

    useEffect(() => {
        const numPages = bookInfo['Number of Pages'];
        setFisicalPage(Math.round(percentage / 100 * numPages));
    }, [percentage, bookInfo['Number of pages']])

  const epubUrl = `https://api.jannekedegraaff.nl/api/library/getEpub/${params.bookId}.epub`;
  if (loading) {
    return(
        <LoaderFull/>
    )
  }

  return (
     <PageLayout
        headerText={bookInfo['Title'] || 'Geen titel gevonden'}
        image={bookInfo['Cover URL'] || NoCover}
        type="dark"
    >
        <div style={{ height: '80vh' }}>
            {bookInfo['EPUB URL'] ?
            (<>
                <ReactReader
                    url={epubUrl}
                    title={bookInfo['Title']}
                    location={location}
                    tocChanged={(_toc) => (toc.current = _toc)}
                    locationChanged={(loc: string) => {
                        setNewLocation(loc)
                    }}
                    getRendition={(_rendition: Rendition) => {
                        rendition.current = _rendition

                        _rendition.book.ready.then(() => {
                            _rendition.book.locations.generate(1000).then(() => {
                            // Bereken percentage als de locatie bekend is
                            if (location) {
                                const percent = _rendition.book.locations.percentageFromCfi(location);
                                setPercentage(Math.round(percent * 100));
                            }
                        });
                    });
                    }}
                />
                {page && (
                    <>
                        <div className="text-sm pb-2 text-right">
                            {page} 
                        </div>
                        <div className='text-sm pb-2 text-right'>
                            You've read {percentage}% of the book (p. ±{fisicalPage} of {bookInfo['Number of Pages']})
                        </div>
                    </>
                )}
            </>
            ) 
            : (
                    <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-[#aba9e4] px-6 py-2.5 sm:px-3.5 sm:before:flex-1 rounded-xl">
                        <div className="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl" aria-hidden="true">
                            <div className="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30" ></div>
                        </div>
                        <div className="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl" aria-hidden="true">
                            {/* <div className="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 bg-gray-900" ></div> */}
                        </div>
                        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                            <p className="text-sm/6 text-gray-900">
                            <strong>Unfortunately the EPUB you are looking for is not available yet.</strong>
                            {/* <strong className="font-semibold">GeneriCon 2023</strong><svg viewBox="0 0 2 2" className="mx-2 inline size-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>Join us in Denver from June 7 – 9 to see what’s coming next. */}
                            </p>
                            <a href={`/Book/${params.bookId}?upload=true`} className="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-xs hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">Upload <span aria-hidden="true">&rarr;</span></a>
                        </div>
                        <div className='flex flex-1 justify-end'></div>
                        </div>
                )
            }
        </div>
     
    </PageLayout>
  );
}

export default Reader;
